const editor = {
    en: {
      options: "Options",
      back: "Back to Article List",
      shortcuts: "Shortcuts Guide",
      article: "Article",
      content: "Content",
      article_content: {
        no_author: "No Author"
      },
      menu: {
        editor: "Editor",
        top_line: "Topline Data",
        sources: "Sources",
        outlets: "Outlets",
        publish: "Publish",
        unpublish: "Un-Publish",
        history: "History"
      },
      top_line: {
        summary: "Summary",
        headline: "Headline",
        translated_headline: "Translated Headline",
        publish_date: "Publish Date",
        ave: "AVE",
        social_ave: "To see AVE breakdown by Organization, go to Query builder",
        impressions: "Impressions",
        comment: 'Comment | Comments',
        additional_info: 'Additional information',
        language: {
          title: "Language",
          select: "Select a language..."
        },
        authors: {
          title: "Authors",
          select: "Search and select an author...",
          placeholder: "Press enter to create author"
        },
        mentions: {
          title: "Mentions",
          select: "Search and select a mention...",
          placeholder: "Press enter to create mention"
        },
        hashtags: {
          title: "Hashtags",
          select: "Search and select a hashtag...",
          placeholder: "Press enter to create hashtag"
        },
        refresh_article_metrics: "Refresh article metrics",
        socials: "Socials",
        handle: "Handle (@) / Profile Name",
        gender: "Gender",
        followers: "No. of Followers",
        sentiment: "Sentiment",
        country: "Country / Location",
        likes: "No. Likes",
        no_comments: "No. Comments",
        shares: "No. Shares / Reposts",
        views: "No. Views",
        reactions: "No. Reactions"
      },
      organization: "Organization | Organizations",
      category: "Category | Categories",
      tags_menu: {
        category_tag_empty: "No category tags found",
        organization_tag_empty: "No organization tags found",
        setup_organization: "Setup organizations on configuration page",
        existing_tag: "Tag {0} already exists"
      },
      advanced_search: "Advanced Search",
      advanced_search_back: "Back",
      search: "Search",
      "search...": "Search...",
      sources: {
        title: "Title",
        select_title: "Select a Title...",
        first_name: "First Name",
        last_name: "Last Name",
        middle_name: "Middle name",
        job_title: "Job Title",
        affiliation: {
          title: "Affiliation",
          select: "Select an Affiliation..."
        },
        category: {
          title: "Category",
          select: "Select a Category..."
        },
        add_source_header: "Add Source",
        add_source_quote: "Add New Quote",
        remove_source: "Remove source",
        sub_title: "Are you sure that you want to delete this source?",
        n_a: "N/A",
        display_name: "Display name"
      },
      tags: {
        add_tag_header: "Add / Edit Tag",
        delete_tag_header: "Delete Tag",
        delete_tag_body: "Are you sure you want to delete tag {0}",
        name: "Tag name",
        add_associated_tags: "Add Associated Tags"
      },
      form: {
        search: "Search",
        save: "Save",
        add: "Add",
        close: "Close",
        clone: "Clone",
        validation_messages: {
          empty_field_error: "{0} cannot be left empty",
          numerical_error: "{0} should be a numerical value",
          invalid_email_error: "{0} is an invalid email address",
          invalid_url_error: "{0} is an invalid link address",
          invalid_syntax_error: "{0} has invalid syntax in value",
          invalid_brackets_error: "{0} has invalid bracket syntax in value",
          select_folder_error: "You must select a folder where to save the query",
          entry_exists: "Value already exists please try another {0}",
          is_not_unique: "{0} has to be unique"
        }
      },
      confirmation: {
        header: {
          back_to_articles: "Back to Articles",
          unpublish: "Un-Publish Clip",
          irrelevant: "Flag as Irrelevant"
        },
        message: {
          default: "Are you sure you want to proceed?",
          back_to_articles: "Changes made will be lost if you leave the Editor. Are you sure you want to leave?",
          unpublish: "Are you sure you want to un-publish this clip?",
          irrelevant: "Are you sure you want to flag this clip as irrelevant?"
        },
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete"
      },
      bias: "Bias",
      prominence: "Prominence",
      clone_mentions: "Clone Organization Mentions",
      pagination: {
        per_page: "Items per Page",
        page_number: "{0} - {1} of {2}",
        order_by: "Order By..."
      },
      tooltip: {
        pending_approval: "Pending Approval",
        approved: "Approved"
      },
      insight: {
        view: "View on Insight"
      },
      translation: {
        view_translation: "View Translation",
        view_original_text: "View Original Text"
      },
      gender: {
        male: "Male",
        female: "Female",
        unknown: "Unknown"
      },
      sentiment: {
        "-2": "Negative",
        "-1": "Slightly Negative",
        "0": "Neutral",
        "1": "Slightly Positive",
        "2": "Positive"
      },
      irrelevant: "Flag as irrelevant",
      flagged_irrelevant: "Flagged as irrelevant",
      enable_sources: "Select an Organisation to enable Sources",
      updated_at: "Updated at",
      coding_history: {
        type: {
          article: "Article",
          organization: "Organization",
          tag: "Tag",
          source: "Source",
          author: "Author"
        },
        action: {
          create: "created",
          update: "updated",
          delete: "deleted",
          bulk_update: "bulk updated"
        },
        compare_fields: {
          relation_tag: "relation tag",
          dominant_tag_positive_mention: "relation tag positive mentions",
          dominant_tag_negative_mention: "relation tag negative mentions",
          positive_mention: "positive mentions",
          negative_mention: "negative mentions",
          article_status: "status",
          headline: "headline",
          translated_headline: "translated headline",
          published_at: "published date",
          ave: "AVE",
          language: "language",
          impression: "impression",
          authors: "authors",
          summary: "summary",
          comments: "comments",
          additional_info: "additional information",
          coder: "coder",
          outlet_name: "outlet"
        }
      },
      most_relevant: 'Most Relevant',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      score: 'Score: ',
      ai_coding_history: {
        title: 'AI Coding History',
        button: 'AI coding',
        labels: {
          date: 'Date',
          relevant: 'Relevant',
          content: 'Content',
          explanation: 'Explanation',
          misc: 'Misc',
          organization: 'Organization',
          category: 'Category',
          tag: 'Tag',
          yes: 'Yes',
          no: 'No',
          na: 'N/A',
          positive: 'Positive',
          negative: 'Negative',
          positive_na: 'Positive N/A',
          negative_na: 'Negative N/A'
        }
      }
    }
};

module.exports.editor = editor;